import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';

export const ADD_COUNTRY: string = "ADD_COUNTRY";
export const CLEAR_COUNTRIES: string = "CLEAR_COUNTRIES";

export const COUNTRY_LOADING: string = "COUNTRY_LOADING";
export const COUNTRY_SUCCESS: string = "COUNTRY_SUCCESS";
export const COUNTRY_FAILED: string = "COUNTRY_FAILED";
export const COUNTRY_CLEAR: string = "COUNTRY_CLEAR";

export function addCountry(cid: string,
    name: string,
    code: string,
    iso_code: string,
    status: string): IAddCountryActionType {
    return { type: ADD_COUNTRY, cid: cid, name: name, code: code, iso_code: iso_code, status: status }
}
export function clearCountries(): IClearCountryActionType {
    return { type: CLEAR_COUNTRIES };
}

export const fetchCountryList = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: COUNTRY_LOADING });
        networkCall(`get`, `/countries`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: COUNTRY_SUCCESS, payload: { res: res } });
                } else {
                    dispatch({ type: COUNTRY_FAILED, payload: { res: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: COUNTRY_FAILED, payload: { error: error.response.data } });
                }
            });
    }
}

export const fetchCountryListAndCode = async () => {
	try {
		const url = `/get-country-code`;
		const resp: any = await networkCall('get', url, apiBaseUrl.baseUrl);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

interface IAddCountryActionType {
    type: string, cid: string,
    name: string,
    code: string,
    iso_code: string,
    status: string
}

interface IClearCountryActionType { 
    type: string 
}